/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { Col, Image, Row, Space } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { ImageFallback } from 'helpers/constanst'
import { selectPosBill } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { ActionButton, PrimaryButton } from 'Components/button'
import ProductsDrawer from './ProductsDrawer'
import { AppInput } from 'Components/form'
import { ProductOptionsWithMaterail } from 'Store/product/types'
import { selectDatas } from 'Store/config/selector'

type Props = {
  products: ProductOptionsWithMaterail[]
  onUpdateData?: (products: ProductOptionsWithMaterail[]) => void
} & ReduxProps

const ProductsTable: React.FunctionComponent<Props> = props => {
  const [chooseProduct, setChooseProduct] = useState(false)
  const { products, onUpdateData = () => {}, configs } = props
  const priceLabel = configs?.value.price_labels || []

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const onUpdateQuantity = (product: ProductOptionsWithMaterail, val: string) => {
    const newProduct = products.map(item => {
      if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
        const quantity = parseInt(val)
        // if (quantity > product.stock) {
        //   quantity = product.stock
        // }
        item.bom_qty = quantity
      }
      return item
    })
    onUpdateData(newProduct)
  }

  const onRemoveProduct = (product: ProductOptionsWithMaterail) => {
    const newProduct =
      products &&
      products.filter(
        item => item.product_id != product.product_id || item.product_option_id != product.product_option_id,
      )
    onUpdateData(newProduct)
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: string, record: ProductOptionsWithMaterail) => {
    const isSameTitle = record.title == record.product_option_title
    return (
      <>
        <RowTile>{record.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
      </>
    )
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="view"
        onClick={() => onRemoveProduct(record)}
      />
    </Space>
  )

  const renderQuantity = (item: string, record: ProductOptionsWithMaterail) => {
    return (
      <AppInput
        name="bom_qty"
        label=""
        type="number"
        errorMsg="จำนวน"
        isRequired={true}
        isError={isNaN(record?.bom_qty || 0) || (record?.bom_qty || 0) <= 0}
        value={record.bom_qty}
        onChange={val => onUpdateQuantity(record, val)}
        key={`${record.product_id}-${record.product_option_id}`}
      />
    )
  }

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  const renderCount = (color: string, title: string, count: any, unit: string = 'ซม.') => (
    <DetailText key={title}>
      <Row justify="space-between" align="top" gutter={[8, 8]}>
        <Col span={16}>{title}</Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          {count}
        </Col>
      </Row>
    </DetailText>
  )

  const renderPrice = (weight: number, record: ProductOptionsWithMaterail) => {
    return (
      <>
        {renderCount('green', 'ราคาขายออนไลน์', numberWithComma(record?.price || 0, true), 'บาท')}
        {renderCount('orange', 'ราคาขายหน้าร้าน', numberWithComma(record?.offline_price || 0, true), 'บาท')}
        {(record?.price_a || 0) > 0 &&
          renderCount('grey', getConfigName('price_a'), numberWithComma(record?.price_a || 0, true), 'บาท')}
        {(record?.price_b || 0) > 0 &&
          renderCount('grey', getConfigName('price_b'), numberWithComma(record?.price_b || 0, true), 'บาท')}
        {(record?.price_c || 0) > 0 &&
          renderCount('grey', getConfigName('price_c'), numberWithComma(record?.price_c || 0, true), 'บาท')}
      </>
    )
  }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'photo',
      key: 'photo',
      width: '80px',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'code',
      key: 'code',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'manufacturer_name',
      key: 'manufacturer_name',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>ราคา (บาท)</ColTile>,
      dataIndex: 'price',
      key: 'price',
      width: '250px',
      render: renderPrice,
    },
    {
      title: <ColTile>สต๊อก</ColTile>,
      dataIndex: 'stock',
      key: 'stock',
      render: (val: number) => numberWithComma(val),
      align: 'right',
    },
    {
      title: '',
      dataIndex: 'key',
      key: 'key',
      width: '30px',
    },
    {
      title: <ColTile>จำนวนที่ใช้ตัดสต๊อก</ColTile>,
      dataIndex: 'bom_qty',
      key: 'bom_qty',
      width: '150px',
      render: renderQuantity,
    },
    {
      title: <ColTile>หน่วย</ColTile>,
      dataIndex: 'uom',
      key: 'uom',
      width: '100px',
    },
    {
      title: '',
      key: 'action',
      width: '50px',
      render: renderActionButton,
    },
  ]

  const ChooseProductsDrawer = (
    <ProductsDrawer
      visible={chooseProduct}
      onCloseDrawer={() => setChooseProduct(false)}
      onSaveProduct={(products: ProductOptionsWithMaterail[]) => {
        onUpdateData(products)
        setChooseProduct(false)
      }}
      products={products}
      customerType={''}
    />
  )

  const renderHeader = () => {
    return (
      <Row justify="space-between" gutter={[32, 32]} align="middle">
        <Col>
          <BoxTitle>เลือกส่วนประกอบสินค้า</BoxTitle>
        </Col>
      </Row>
    )
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          {renderHeader()}
          <TableListPage
            rowKey="product_option_id"
            tableName="product-purchase"
            columns={columns}
            datas={products}
            size={'small'}
          />
        </Col>
      </Row>
      <Row justify="space-between" gutter={[8, 8]}>
        <Col>
          <PrimaryButton
            btnType="Approve"
            text="เพิ่มสินค้า"
            onClick={() => setChooseProduct(true)}
            icon={<PlusOutlined />}
            size="middle"
          />
        </Col>
      </Row>
      {ChooseProductsDrawer}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const DetailText = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-weight: 100;
  line-height: 1;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  padding-right: 10px;
`

const mapStateToProps = (state: RootState) => {
  return {
    billData: selectPosBill(state),
    configs: selectDatas(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsTable)
